import React from 'react';
import Header from './components/Header/Header';
import Hero from './components/Hero/Hero';
import About from './components/About/About';
import Order from './components/Order/Order';
import Documents from './components/Documents/Documents';
import Advantages from './components/Advantages/Advantages';
import Reviews from './components/Reviews/Reviews';
import Examples from './components/Examples/Examples';
import Contact from './components/Contact/Contact';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className='app'>
      <Header />
      <Hero />
      <About />
      <Order />
      <Documents />
      <Advantages />
      <Reviews />
      <Examples />
      <Contact />
      <Footer />
    </div>
  );
}

export default App;